__turbopack_context__.v({
  "productListItem": "_2wDP6G_productListItem",
  "searchTerm": "_2wDP6G_searchTerm",
  "seeMoreText": "_2wDP6G_seeMoreText",
});
